<template>
  <div>
    <component
      :key="`${view}_${since}_${until}`"
      :is="component"
      :accountId="accountId"
      :since="since"
      :until="until"
    />
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    view: {
      type: String,
      default: '',
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  computed: {
    component() {
      const componentByView = {
        tactics: () => import('./components/TacticList.vue'),
        'email-campaigns': () => import('./components/EmailCampaignList.vue'),
        'sms-campaigns': () => import('./components/SmsCampaignList.vue'),
        'google-ads': () => import('./components/GoogleAdList.vue'),
        'facebook-ad-posts': () => import('./components/FacebookPageAdPosts.vue'),
        'instagram-ad-posts': () => import('./components/InstagramAdPosts.vue'),
        'facebook-posts': () => import('./components/FacebookPagePosts.vue'),
        'instagram-posts': () => import('./components/FacebookPageInstagramPosts.vue'),
        'blog-posts': () => import('./components/BlogPostList.vue'),
        'facebook-campaigns': () => import('./components/FacebookCampaignList.vue'),
        default: 'div',
      };

      return componentByView[this.view] || componentByView.default;
    },
  },
};
</script>
